﻿(function (angular, Hashes) {
  "use strict";

  var FRACTION_TO_PERCENT_MULTIPLIER = 100;

  angular
    .module("Toyota.Filters", [])
    .filter("formatArgs", [
      function () {
        // pass url and array of arguments.
        return function (url, args) {
          var result = url;
          // Loop through arguments and replace url value.
          angular.forEach(args, function (value, key) {
            result = result.replace("{" + key + "}", value);
          });

          return result;
        };
      },
    ])
    .filter("formatPrice", [
      "$filter",
      function ($filter) {
        return function (number) {
          return $filter("currency")(Math.ceil(number), "$", 0);
        };
      },
    ])
    .filter("formatPriceWithCents", [
      "$filter",
      function ($filter) {
        return function (number) {
          return $filter("currency")(number, "$", 2);
        };
      },
    ])
    .filter("formatPercentage", [
      "$filter",
      function ($filter) {
        return function (number, decimals, symbol) {
          var showPercent = typeof symbol !== "undefined" ? symbol : true;
          var percent = showPercent ? "%" : "";
          return $filter("number")(number * FRACTION_TO_PERCENT_MULTIPLIER, decimals || 1) + percent;
        };
      },
    ])
    .filter("formatNumber", [
      "$filter",
      function ($filter) {
        return function (number) {
          return $filter("number")(number, 0);
        };
      },
    ])
    .filter("formatSuper", [
      function () {
        return function (string) {
          if (!angular.isString(string)) {
            return "";
          }

          return string.replace(/(\[.*?])/g, "<sup>$1</sup>");
        };
      },
    ])
    .filter("removeSpaces", function () {
      return function (string) {
        if (!angular.isString(string)) {
          return string;
        }

        return string.replace(/[\s]/g, "");
      };
    })
    .filter("arrayFind", function () {
      return function (array, visitor, thisArg) {
        for (var i = 0; i < array.length; i++) {
          if (visitor.call(thisArg, array[i], i, array)) {
            return array[i];
          }
        }

        return undefined;
      };
    })
    .filter("twoDecimalPlacesString", function () {
      return function (num) {
        // eslint-disable-next-line no-magic-numbers
        return (Math.round(parseFloat(num) * 100) / 100).toString();
      };
    })
    .filter("arrayIntersect", function () {
      return function (a, b) {
        if (!(a instanceof Array && b instanceof Array)) {
          throw new Error("Both arguments must be an Array");
        }

        return a
          .filter(function (element) {
            return b.indexOf(element) > -1;
          })
          .filter(function (element, index, intermediateArray) {
            return intermediateArray.indexOf(element) === index;
          });
      };
    })
    .filter("arraySubtract", function () {
      return function (a, b) {
        if (!(a instanceof Array && b instanceof Array)) {
          throw new Error("Both arguments must be an Array");
        }

        return a.filter(function (element) {
          return b.indexOf(element) === -1;
        });
      };
    })
    .filter("arrayUnique", function () {
      return function (array) {
        return array.filter(function (elem, index, array) {
          return index === array.indexOf(elem);
        });
      };
    })
    .filter("SHA256", function () {
      return function (string) {
        return new Hashes.SHA256().hex(string);
      };
    });
})(window.angular, window.Hashes);
